import { COMMON_CHUNK_NAME } from '../../const/generator';

import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IUtilInfo,
} from '../../types';

const pluginFactory: BuilderComponentPluginFactory<string> = (baseFramework?: string) => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const framework = baseFramework || 'react';
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IUtilInfo;

    if (ir.utils) {
      const allDependencies = ir.utils.map((util) => util.dependencies).filter(Boolean);
      // 每个 util 的 dependencies 单独作为一个 chunk，由 ChunkBuilder 统一去重合并
      for (const dep of allDependencies) {
        next.chunks.push({
          type: ChunkType.STRING,
          fileType: FileType.TSX,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: dep,
          linkAfter: [],
        });
      }
      const exportUtils = ir.utils.filter((util) => util.export);
      const exportDefaultUtils = ir.utils.filter((util) => !util.export);
      if (exportUtils) {
        exportUtils.forEach((util) => {
          if (util.type === 'function') {
            next.chunks.push({
              type: ChunkType.STRING,
              fileType: FileType.TSX,
              name: COMMON_CHUNK_NAME.FileExport,
              content: `
                export const ${util.name} = ${util.content.value};
              `,
              linkAfter: [
                COMMON_CHUNK_NAME.ExternalDepsImport,
                COMMON_CHUNK_NAME.InternalDepsImport,
                COMMON_CHUNK_NAME.ImportAliasDefine,
              ],
            });
          }
        });
      }
      next.chunks.push({
        type: ChunkType.STRING,
        fileType: FileType.TSX,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
          export default {
        `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent,
        ],
      });

      exportDefaultUtils.forEach((util) => {
        if (util.type === 'function') {
          next.chunks.push({
            type: ChunkType.STRING,
            fileType: FileType.TSX,
            name: COMMON_CHUNK_NAME.FileVarDefine,
            content: `
              const ${util.name} = ${util.content.value};
            `,
            linkAfter: [
              COMMON_CHUNK_NAME.ExternalDepsImport,
              COMMON_CHUNK_NAME.InternalDepsImport,
              COMMON_CHUNK_NAME.ImportAliasDefine,
            ],
          });
        }

        next.chunks.push({
          type: ChunkType.STRING,
          fileType: FileType.TSX,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `${util.name},`,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent,
          ],
        });
      });

      next.chunks.push({
        type: ChunkType.STRING,
        fileType: FileType.TSX,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
          };
        `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent,
        ],
      });
    }

    return next;
  };
  return plugin;
};

export default pluginFactory;
